import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { projectStore, useScreen } from "@/hooks";
import { Routes } from "@/router";
import { ProjectSelector, VersionSelector } from "@/components/project";
import { ViewSelector } from "@/components/view";
import { IconButton, Typography } from "@/components/common";
import { OrganizationSelector } from "@/components/organization";
import FlexBox from "@/components/common/display/content/FlexBox.vue";


/**
 * Displays breadcrumbs for navigating between the current org, team, project, and version.
 */
const __default__ = {
  name: "NavBreadcrumbs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();
const currentRoute = useRoute();

const collapsed = ref(true);

const displayMore = computed(
  () => smallWindow.value && currentRoute.path === Routes.ARTIFACT
);

const displayOptions = computed(() => !smallWindow.value || !collapsed.value);

const displayOrgOptions = computed(
  () => currentRoute.path === Routes.ORG || currentRoute.path === Routes.TEAM
);

const displayProjectOptions = computed(
  () =>
    displayOptions.value &&
    projectStore.isProjectDefined &&
    currentRoute.path === Routes.ARTIFACT
);

const pageTitle = computed(() =>
  currentRoute.name ? String(currentRoute.name) : undefined
);
const pageDescription = computed(
  () => currentRoute.meta.description as string | undefined
);

const displayPageTitle = computed(
  () => !displayProjectOptions.value && !!pageTitle.value && !collapsed.value
);

return (_ctx: any,_cache: any) => {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_breadcrumbs, {
      gutter: "xs",
      class: "nav-breadcrumb-list",
      "separator-color": "grey"
    }, {
      default: _withCtx(() => [
        (displayOrgOptions.value)
          ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(OrganizationSelector))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!displayOrgOptions.value)
          ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ProjectSelector))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (displayProjectOptions.value)
          ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_unref(VersionSelector))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (displayProjectOptions.value)
          ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, { key: 3 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ViewSelector))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (displayPageTitle.value)
          ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, { key: 4 }, {
              default: _withCtx(() => [
                _createVNode(FlexBox, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Typography), {
                      variant: "subtitle",
                      el: "h1",
                      value: pageTitle.value,
                      x: "2",
                      color: "text"
                    }, null, 8, ["value"]),
                    (pageDescription.value)
                      ? (_openBlock(), _createBlock(_unref(IconButton), {
                          key: 0,
                          tooltip: pageDescription.value,
                          icon: "info",
                          color: "grey",
                          small: ""
                        }, null, 8, ["tooltip"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (displayMore.value)
      ? (_openBlock(), _createBlock(_unref(IconButton), {
          key: 0,
          tooltip: "Toggle more options",
          class: "q-mx-sm",
          color: "text",
          icon: collapsed.value ? 'down' : 'up',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (collapsed.value = !collapsed.value))
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})